//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Settings Right Component File
//  * @description -   This file renders the html and functionality that renders at right panel for settings tab.
<template>
  <div class="col-md-3 p-0 col-xs-12 survey_colume_3">
    <div class="colume_3_build sticky_bar"></div>
  </div>
</template>
<script>
export default {
  name: "rightsetting",
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/rightsetting.vue